var map = {
	"./goldcoin/squad-icon-2.png": 85913,
	"./memetown/squad-icon-2.png": 97192,
	"./reflection/squad-icon-2.png": 91421,
	"./tapcoin/squad-icon-2.png": 44481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75784;